import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { LoaderIcon } from 'lucide-react';
import { useEffect } from 'react';
import { z } from 'zod';

import { installationUrl } from '@/lib/installation';
import { installationsQuery, useCurrentOrg, useCurrentOrgMutators } from '@/services/org';

export const Route = createFileRoute('/auth/callback')({
  validateSearch: zodValidator(
    z.object({
      redirectTo: z.string().default('/pulls'),
      signUp: z.boolean().default(false),
    })
  ),
  loaderDeps: ({ search: { redirectTo, signUp } }) => ({ redirectTo, signUp }),
  loader: async () => {
    console.log('loading auth callback', location.pathname);
  },
  component: () => <AuthComponent />,
});

// This needs to be a component. If we put all this logic in a loader then the Clerk provider
// doesn't register that the user completed their login and then on signup after the installation callback
// the user is seen as not signed in.
const AuthComponent = () => {
  const { queryClient } = Route.useRouteContext();
  const { redirectTo } = Route.useLoaderDeps();
  const navigate = useNavigate();
  const { setCurrentOrg } = useCurrentOrgMutators();

  const setOrgOrInstall = async () => {
    const installations = await queryClient.fetchQuery(installationsQuery());

    if (installations.length === 0) {
      navigate({ to: '/install' });
      return;
    }

    setCurrentOrg(installations[0]);
    console.log('redirecting to', redirectTo);
    navigate({ to: !redirectTo || redirectTo.length === 0 ? '/pulls' : redirectTo });
    return;
  };

  useEffect(() => {
    setOrgOrInstall();
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <LoaderIcon className="h-8 w-8 animate-spin text-stone-600" />
      <span className="ml-2 text-stone-600">Completing login...</span>
    </div>
  );
};
